import Link from './src/link.vue'
import { withInstall } from '@el-plus/utils/with-install'

export const EpLink = withInstall(Link)
export default EpLink
export * from './src/link'
